import { Box, Divider, Icon, IconButton, styled, Typography } from "@mui/material";
import { handleRetrieveBlogs } from "../../../redux/public-slices/blog.slice";
import { FILE_PATH_URI, slickSettings } from "../../../utils/helper";
import SkeletonImage from "../../../components/ui/SkeletonImage";
import { useEffect, useRef, useState } from "react";
import Icons from "../../../assets/js/Icons";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import moment from "moment";

const Span = styled("span")(() => ({}));

function Related({ id, currentBlogId }) {
  const dispatch = useDispatch();
  const [data, setData] = useState([]);

  const setting = {
    ...slickSettings,
    dots: true,
    speed: 1000,
    slidesToShow: 3,
    infinite: true,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
    customPaging: () => (
      <Span
        sx={{
          mt: 2,
          mx: "auto",
          height: "5px",
          width: "20px",
          display: "block",
          bgcolor: "divider",
          borderRadius: "4px",
        }}
      />
    ),
  };

  const slickRef = useRef(null);

  const slickNext = () => {
    slickRef?.current?.slickNext();
  };

  const slickPrev = () => {
    slickRef?.current?.slickPrev();
  };

  const handleRetrieveAll = async (filters) => {
    const response = await dispatch(
      handleRetrieveBlogs({
        categoryId: id || null,
      })
    ).unwrap();
    const related = response?.records?.filter(
      (blog) => blog?.categoryId === id && blog?._id !== currentBlogId
    );
    setData(related);
  };

  useEffect(() => {
    handleRetrieveAll();
    // eslint-disable-next-line
  }, [id, currentBlogId]);

  return (
    <>
      {data && data.length > 0 && (
        <Box
          my={10}
          sx={{
            ".slick-dots": { position: "initial" },
            ".slick-dots .slick-active span": {
              bgcolor: "secondary.main",
            },
          }}
        >
          <Box textAlign="center" mb={3}>
            <Typography
              fontSize={28}
              fontWeight="700"
              textAlign="center"
              color="other.color1"
            >
              Related posts
            </Typography>
            <Divider
              sx={{
                mt: 2,
                mx: "auto",
                maxWidth: "200px",
                borderWidth: "1.5px",
                borderColor: "secondary.main",
              }}
            />
          </Box>

          <Box position="relative" mx={2.2}>
            <IconButton
              sx={{
                left: "-10px",
                width: "40px",
                height: "40px",
                ":hover": { backgroundColor: "secondary.main" },
              }}
              variant="slickPrev"
              onClick={slickPrev}
            >
              <Icon>
                <Icons.ArrowRight1 />
              </Icon>
            </IconButton>
            <IconButton
              sx={{
                right: "-10px",
                width: "40px",
                height: "40px",
                ":hover": { backgroundColor: "secondary.main" },
              }}
              variant="slickNext"
              onClick={slickNext}
            >
              <Icon>
                <Icons.ArrowRight1 />
              </Icon>
            </IconButton>
            <Slider ref={slickRef} {...setting}>
              {data.length === 1
                ? [data?.[0], data?.[0], data?.[0]].map((element, i) => (
                  <Box
                    key={i}
                    px={1}
                    sx={{ my: 2, display: "flex", justifyContent: "center" }}
                  >
                    <Box
                      sx={{
                        p: 2,
                        mt: 2,
                        gap: 3,
                        display: "flex",
                        width: "100%",
                        flexDirection: "column",
                        boxShadow: "0 0 10px 0 #00000020",
                        height: { xs: "auto", sm: 300, md: 320 },
                        // margin: data?.length <= 1 ? "auto" : "0",
                        transition: "all 0.3s ease",
                        "&:hover": {
                          transform: "translate3d(0, -5px, 0) scale(1)",
                          padding: "20px",
                          boxShadow: "2px 2px 13px rgba(0, 0, 0, 0.2)",
                        },
                      }}
                    >
                      {" "}
                      <Box
                        sx={{
                          width: "100%",
                          overflow: "hidden",
                          borderRadius: "6px",
                          aspectRatio: "1/0.6",
                        }}
                        component={Link}
                        to={`/blog/${element?._id}`}
                      >
                        <SkeletonImage
                          src={FILE_PATH_URI + (element?.banner?.path || element?.banner?.source || "")}
                        />
                      </Box>
                      <Typography fontWeight="500" color="other.color2">
                        {" "}
                        {moment(element?.createdAt).format("MMM DD YYYY")}
                      </Typography>
                      <Typography
                        sx={{
                          width: "100%",
                          fontSize: "18px",
                          fontWeight: "600",
                          lineHeight: "1.3",
                          overflow: "hidden",
                          WebkitLineClamp: 2,
                          color: "other.color1",
                          display: "-webkit-box",
                          WebkitBoxOrient: "vertical",
                          mt: "auto",
                        }}
                        component={Link}
                        to={`/blog/${element?._id}`}
                      >
                        {element?.title}
                      </Typography>
                    </Box>
                  </Box>
                ))
                : data?.map((element, i) => (
                  <Box
                    key={i}
                    px={1}
                    sx={{ my: 2, display: "flex", justifyContent: "center" }}
                  >
                    <Box
                      sx={{
                        p: 2,
                        mt: 2,
                        gap: 3,
                        width: "100%",
                        display: "flex",
                        flexDirection: "column",
                        transition: "all 0.3s ease",
                        boxShadow: "0 0 10px 0 #00000020",
                        height: { xs: "auto", sm: 300, md: 320 },
                        "&:hover": {
                          transform: "translate3d(0, -5px, 0) scale(1)",
                          padding: "20px",
                          boxShadow: "2px 2px 13px rgba(0, 0, 0, 0.2)",
                        },
                      }}
                    >
                      {" "}
                      <Box
                        sx={{
                          width: "100%",
                          overflow: "hidden",
                          borderRadius: "6px",
                          aspectRatio: "1/0.6",
                        }}
                        component={Link}
                        to={`/blog/${element?._id}`}
                      >
                        <SkeletonImage
                          src={FILE_PATH_URI + (element?.banner?.path || element?.banner?.source || "")}
                        />
                      </Box>
                      <Typography fontWeight="500" color="other.color2">
                        {" "}
                        {moment(element?.createdAt).format("MMM DD YYYY")}
                      </Typography>
                      <Typography
                        sx={{
                          width: "100%",
                          fontSize: "18px",
                          fontWeight: "600",
                          lineHeight: "1.3",
                          overflow: "hidden",
                          WebkitLineClamp: 2,
                          color: "other.color1",
                          display: "-webkit-box",
                          WebkitBoxOrient: "vertical",
                          mt: "auto",
                          textDecoration: "none"
                        }}
                        component={Link}
                        to={`/blog/${element?._id}`}
                      >
                        {element?.title}
                      </Typography>
                    </Box>
                  </Box>
                ))}
            </Slider>
          </Box>
        </Box>
      )}
    </>
  );
}

export default Related;
